<div class="truck-registration-masterdata">
    <sc-padding>
        <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
            <sc-content-spacer [vertical]="true" [grow]="true"></sc-content-spacer>
            <ng-container [formGroup]="masterdataForm">

                <mat-form-field>
                    <input matInput name="numberplate" formControlName="numberplate"
                        placeholder="{{'numberplate' | translate: ['tmc-yard.entity.truck.numberplate', translationService.language]}}"
                        [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field>
                    <input matInput name="carrier" formControlName="carrier"
                        placeholder="{{'carrier' | translate: ['tmc-yard.entity.truck.carrier', translationService.language]}}"
                        [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field>
                    <input matInput name="supplier" formControlName="supplier"
                        placeholder="{{'supplier' | translate: ['tmc-yard.entity.truck.supplier', translationService.language]}}"
                        [required]="false" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field>
                    <input matInput name="driver" formControlName="driver"
                        placeholder="{{'driver' | translate: ['tmc-yard.entity.truck.driver', translationService.language]}}"
                        [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field>
                    <input matInput name="coDriver" formControlName="coDriver"
                        placeholder="{{'co driver' | translate: ['tmc-yard.entity.truck.co-driver', translationService.language]}}"
                        [required]="false" minlength="row.minLength" maxlength="255">
                </mat-form-field>

            </ng-container>
            <sc-content-spacer [vertical]="true" [grow]="true"></sc-content-spacer>
        </sc-flex>
    </sc-padding>
</div>